import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function TabsList({ children }) {
    return (
        <div className="flex border-b border-gray-700 space-x-0 overflow-x-auto">
            {children}
        </div>
    );
}

export function TabsTrigger({ text, value, onClick }) {
    const pathname = useLocation().pathname;
    const isActive = pathname.indexOf(value);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <button
            onClick={handleClick}
            className={`px-6 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-all duration-300 ${
                isActive >= 0
                    ? "border-blue-500 text-blue-400 bg-blue-500/10"
                    : "border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-500"
            }`}
        >
            {text}
        </button>
    );
}

export default function TabList() {
    const navigate = useNavigate();

    return (
        <TabsList>
            <TabsTrigger
                text="📡 Networks"
                value="network"
                onClick={() => navigate("/admin/network")}
            />
            <TabsTrigger
                text="🔗 Subnets"
                value="subnet"
                onClick={() => navigate("/admin/subnet")}
            />
            <TabsTrigger
                text="🔌 Routes"
                value="route"
                onClick={() => navigate("/admin/")}
            />
            <TabsTrigger
                text="🛡️ Security Groups"
                value="security-group"
                onClick={() => navigate("/admin/security-group")}
            />
        </TabsList>
    );
}
